export enum BucketType {
  Cable = "cable",
  Digger = "digger",
  Sorting = "sorting",
  Utility = "utility",
}
